import { createFileRoute } from '@tanstack/react-router';
import { AuditLogPage } from '@/components/finance';

// FSU shell unification: audit log absorbed under the Settings sub-nav.
// Capability gating (Finance.Manage) is enforced by the sub-nav rendering
// in `FinanceSettingsLayout`, but the page itself remains accessible at
// this URL for deep-linking.
export const Route = createFileRoute('/admin/finance/settings/audit-log')({
  component: AuditLogPage,
});
